import { defineMessages } from 'react-intl'

export default defineMessages({
  attributePossessive: {
    id: 'SpaceAppBuilderFeaturesPage.operation.boolean.BooleanSimpleRule.Attribute.Possessive',
    defaultMessage: '{leftComparator} equals {rightComparator}'
  },
  notAttributePossessive: {
    id: 'SpaceAppBuilderFeaturesPage.operation.boolean.BooleanSimpleRule.Attribute.Not.Possessive',
    defaultMessage: '{leftComparator} does not equal {rightComparator}'
  },
  contains: {
    id: 'SpaceAppBuilderFeaturesPage.operation.boolean.BooleanSimpleRule.Attribute.Contains',
    defaultMessage: '{leftComparator} contains {rightComparator}'
  },
  startsWith: {
    id: 'SpaceAppBuilderFeaturesPage.operation.boolean.BooleanSimpleRule.Attribute.StartsWith',
    defaultMessage: '{leftComparator} starts with {rightComparator}'
  },
  endsWith: {
    id: 'SpaceAppBuilderFeaturesPage.operation.boolean.BooleanSimpleRule.Attribute.EndsWith',
    defaultMessage: '{leftComparator} ends with {rightComparator}'
  },
  hasValue: {
    id: 'SpaceAppBuilderFeaturesPage.operation.boolean.BooleanSimpleRule.Attribute.HasValue',
    defaultMessage: '{leftComparator} has value'
  },
  greaterThan: {
    id: 'SpaceAppBuilderFeaturesPage.operation.boolean.BooleanSimpleRule.Attribute.GreaterThan',
    defaultMessage: '{leftComparator} is greater than {rightComparator}'
  },
  greaterThanOrEqual: {
    id: 'SpaceAppBuilderFeaturesPage.operation.boolean.BooleanSimpleRule.Attribute.GreaterThanOrEqual',
    defaultMessage: '{leftComparator} is greater than or equal to {rightComparator}'
  },
  lessThan: {
    id: 'SpaceAppBuilderFeaturesPage.operation.boolean.BooleanSimpleRule.Attribute.LessThan',
    defaultMessage: '{leftComparator} is less than {rightComparator}'
  },
  lessThanOrEqual: {
    id: 'SpaceAppBuilderFeaturesPage.operation.boolean.BooleanSimpleRule.Attribute.LessThanOrEqual',
    defaultMessage: '{leftComparator} is less than or equal to {rightComparator}'
  },
  conditionSentence: {
    id: 'SpaceAppBuilderFeaturesPage.operation.boolean.BooleanSimpleRule.Sentence',
    defaultMessage: 'If {conditionText}'
  },
  and: {
    id: 'SpaceAppBuilderFeaturesPage.operation.boolean.BooleanSimpleRule.And',
    defaultMessage: 'AND'
  }
})
